import React from 'react';
import { useDispatch } from 'react-redux';
import Circus from './Circus';
import { AnimationContext } from './AnimationContext';
import { canInteractWithAnimation } from '../../hooks/meeting';
import { useRemoteChopardAnimationState } from '../../hooks/chopard';
import {
  ChopardAnimation,
  IChopardCircusState
} from '../../../interfaces/chopard';
import { throttle } from 'lodash';
import { DID_UPDATE_ANIMATION_STATE } from '../../../utils/constants';
import { logEvent } from '../../../analytics';
import { actionDidUpdateChopardAnimation } from '../../../redux/customActions/chopard';

const CircusWrapper = () => {
  const { setLoaded } = React.useContext(AnimationContext);

  const viewOnly = !canInteractWithAnimation();

  const remoteCircusAnimationState = useRemoteChopardAnimationState(
    ChopardAnimation.CIRCUS
  );

  const dispatch = useDispatch();

  const logEventThrottled = throttle(
    (state: IChopardCircusState) => {
      logEvent(DID_UPDATE_ANIMATION_STATE, DID_UPDATE_ANIMATION_STATE, {
        animation: ChopardAnimation.CIRCUS,
        state
      });
    },
    1000,
    { trailing: true }
  );

  const throttledUpdateRemoteState = throttle((state: IChopardCircusState) => {
    dispatch(actionDidUpdateChopardAnimation(ChopardAnimation.CIRCUS, state));
  }, 50);

  const updateRemoteState = (state: IChopardCircusState) => {
    throttledUpdateRemoteState(state);
    logEventThrottled(state);
  };

  return (
    <>
      <Circus
        remoteState={remoteCircusAnimationState}
        updateRemoteState={updateRemoteState}
        onReady={() => setLoaded(true)}
        viewOnly={viewOnly}
      />
    </>
  );
};
export default CircusWrapper;
